import { MusicExploreCard } from "@/components/MusicExploreCard";
import { ChevronLeftIcon, ChevronRightIcon } from "@/components/icons";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import React from "react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import theme from "../../styles/theme";

SwiperCore.use([Navigation, Pagination]);

const PlaylistSwiper = ({
  playlists,
  active,
  prefix,
  imageRatioSquare,
  onPlay,
  ...props
}) => {
  const swiperRef = React.useRef(null);

  const handlePlayed = (playlist) => {
    if (onPlay && typeof onPlay === "function") {
      onPlay(playlist);
    }
  };

  return (
    <Grid item xs={12}>
      <Box sx={{ position: "relative" }}>
        <Swiper
          ref={swiperRef}
          spaceBetween={24}
          pagination={{ clickable: true }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
            1536: {
              slidesPerView: 4,
            },
          }}
        >
          {playlists.map((playlist, idx) => {
            return (
              <SwiperSlide key={playlist.id}>
                <MusicExploreCard
                  variant="MusicExploreCard"
                  playlist={playlist}
                  active={active}
                  prefix={prefix}
                  imageRatioSquare={imageRatioSquare}
                  onPlay={handlePlayed}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="swiper-previous-button">
          <IconButton
            color="primary"
            aria-label="previous"
            component="span"
            onClick={() => swiperRef.current.swiper.slidePrev()}
          >
            <SvgIcon
              color="secondary"
              sx={{
                fontSize: 24,
                color: theme.palette.secondary.main,
                [theme.breakpoints.up("sm")]: {
                  fontSize: 58,
                },
              }}
            >
              <ChevronLeftIcon />
            </SvgIcon>
          </IconButton>
        </div>
        <div className="swiper-next-button">
          <IconButton
            color="primary"
            aria-label="previous"
            component="span"
            onClick={() => swiperRef.current.swiper.slideNext()}
          >
            <SvgIcon
              color="secondary"
              sx={{
                fontSize: 24,
                color: theme.palette.secondary.main,
                [theme.breakpoints.up("sm")]: {
                  fontSize: 58,
                },
              }}
            >
              <ChevronRightIcon />
            </SvgIcon>
          </IconButton>
        </div>
      </Box>
    </Grid>
  );
};

export default PlaylistSwiper;
